import React, { useState, useEffect, useRef } from 'react'
import DashboardLayout from './DashboardLayout'
import { toast, ToastContainer } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { corporateShowEmployeesAPI, corporateShowSingleEmployeesAPI, corporateUpdateEmployeeAPI } from '../../../redux/slices/CorporateAddEmployee'
import { useFormik } from 'formik'
import { corporateAddEmployeeValidationSchema } from '../../../schemas/corporateaddemployevalidaionschema'
import { corporateEditEmployeeSchema } from '../../../schemas/corporateEditEmployeSchema'
import { professionalDeleteService, ProfessionalServicesAPI } from '../../../redux/slices/ProfessionalServcicesSlice'
import { base, errorHandler, services } from '../../../constants/base'
import { StandaloneSearchBox, GoogleMap, useJsApiLoader, } from '@react-google-maps/api'

const UpdateEmployee = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const param = useParams()
    const employee_id = param?.id;
    const user = useSelector((state) => state?.AuthSlice?.user);
    const singleUserDetial = useSelector(state => state?.coporateAddEmployeSlice?.singleUserDetial)
    const employeeLoading = useSelector(state => state?.coporateAddEmployeSlice?.employeeLoading)
    const loading = useSelector(state => state?.ProfessionalAddServicesSlice?.loading)
    const updateEmployeeloading = useSelector(state => state?.coporateAddEmployeSlice?.updateEmployeeloading)

    // IMAGE UPDATE SECTION

    const imagePreview = singleUserDetial?.images?.[0]?.path;
    const [employeeImagePreview, setEmployeeImagePreview] = useState(null);

    const otherPreview = singleUserDetial?.images?.[1]?.path;
    const [showOtherDocument, setShowOtherDocument] = useState("")

    useEffect(() => {
        if (imagePreview) {
            setEmployeeImagePreview(`${base.imageUrl}${imagePreview}`);
        }
        if (otherPreview) {
            setShowOtherDocument(otherPreview)
        }
    }, [imagePreview]);

    const handleImageChange = (e) => {
        const file = e.currentTarget.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setEmployeeImagePreview(reader.result);
        };
        if (file) {
            reader.readAsDataURL(file);
            formik.setFieldValue('profile', file);
        }
    };

    const handleDocumentChange = (e) => {
        const file = e.currentTarget.files[0];

        if (file) {
            formik.setFieldValue('other', file);
            setShowOtherDocument(file.name);
        }
    };
    // IMAGE UPDATE SECTION

    //????????????????????????????????????????
    // GOOGLE API LOCATION
    const inputRef = useRef(null);
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

    const [getLocationAttributes, setGetLocationAttributes] = useState({})

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_API_KEY,
        libraries: ["places"]
    });

    const handlePlacesChange = () => {
        const places = inputRef.current.getPlaces();
        if (places && places?.length > 0) {
            const place = places[0];
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            setCoordinates({ lat, lng });
            formik.setFieldValue('address', place.formatted_address);
            formik.setFieldValue('latitude', lat);
            formik.setFieldValue('longitude', lng);
            setGetLocationAttributes({
                address: place.formatted_address,
                longitude: lng,
                latitude: lat
            });
        }
    };

    // GOOGLE API LOCATION

    const getSingleUser = async () => {
        const response = await dispatch(corporateShowSingleEmployeesAPI({ user, employee_id }));
    }

    useEffect(() => {
        getSingleUser();
    }, [employee_id, user]);

    const formik = useFormik({
        initialValues: {
            name: singleUserDetial?.name || "",
            phone_no: singleUserDetial?.phone_no || "",
            ss_number: singleUserDetial?.ss_number || "",
            email: singleUserDetial?.email || "",
            address: singleUserDetial?.address?.address || "",
            about: singleUserDetial?.about || "",
            profile: null,
            other: null,
            latitude: singleUserDetial?.address?.latitude || "",
            longitude: singleUserDetial?.address?.longitude || "",
            user_id: user?.id
        },
        validationSchema: corporateEditEmployeeSchema,
        enableReinitialize: true,

        onSubmit: async (values) => {
            const formData = new FormData();
            if (values.profile) {
                formData.append('profile', values.profile);
            }
            if (values.other) {
                formData.append('other', values.other);
            }
            Object.keys(values).forEach((key) => {
                if (key !== 'profile' && key !== 'other') {
                    formData.append(key, values[key]);
                }
            });

            const formDataObject = Object.fromEntries(formData.entries());

            const res = await dispatch(corporateUpdateEmployeeAPI({ data: formData, employee_id }));

            if (corporateUpdateEmployeeAPI.fulfilled(res)) {
                if (res.payload.status === 200) {
                    toast.success('Profile updated successfully!');
                    await dispatch(corporateShowEmployeesAPI(user));
                    navigate('/corporate/employees')
                } else {
                    errorHandler(res.payload.errors);
                }
            } else if (corporateUpdateEmployeeAPI.rejected(res)) {
                errorHandler(res.payload.errors);
            } else {
                toast.error('Sorry, something went wrong!');
            }
        }
    });

    ///////////////////////////SERVICES ADD AGAINST EMPLOYE/////////////////////////////////
    const [addServicesFormData, setAddServicesFormData] = useState({
        name: '',
        currency: '$',
        price: '',
        user_id: employee_id,
        corporate_id: user?.id,
    });

    const addServiceshandleChange = (e) => {
        const { name, value } = e.target;
        setAddServicesFormData({
            ...addServicesFormData,
            [name]: value
        });
    };

    const addServiceshandleSubmit = async (e) => {
        e.preventDefault();
        const res = await dispatch(ProfessionalServicesAPI(addServicesFormData));

        if (res.type === 'ProfessionalServicesAPI/fulfilled') {
            if (res?.payload?.success || res?.payload?.status === 200) {
                const closeButton = document.querySelector("#close-btn-services");
                if (closeButton) {
                    closeButton.click();
                }
            } else {
                errorHandler(res?.payload?.errors);
            }
        } else if (res.type === 'ProfessionalServicesAPI/rejected') {
            errorHandler(res?.payload?.errors);
        } else {
            toast.error('Sorry, something went wrong!');
        }

        const response = await dispatch(corporateShowSingleEmployeesAPI({ user, employee_id }));
    };

    const employeeServicesDelete = async (id) => {
        const res = await dispatch(professionalDeleteService(id))
        const response = await dispatch(corporateShowSingleEmployeesAPI({ user, employee_id }));
    }
    ///////////////////////////SERVICES ADD AGAINST EMPLOYE/////////////////////////////////

    return (
        <>
            <ToastContainer />

            <DashboardLayout>
                <div className="add-employee-box">
                    <div className="container">
                        {
                            employeeLoading ? <div className='d-flex justify-content-center'> <i
                                style={{ fontSize: "32px" }}
                                className="fa-solid fa-spinner fa-spin"
                            ></i></div> : <div className="row">
                                <div className="col-md-7">
                                    <div className="employee-form-box">
                                        <h1>Update Employee</h1>
                                        <h2>Basic Information:</h2>
                                    </div>

                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="form-box-inputs custom-input-box flex-column">
                                            <input
                                                type="text"
                                                value={formik.values.name}
                                                placeholder="Full Name"
                                                name="name"
                                                onChange={formik.handleChange}
                                            />
                                        </div>

                                        <div className="form-box-inputs custom-input-box flex-column">
                                            <input
                                                type="number"
                                                value={formik.values.phone_no}
                                                placeholder="Phone Number"
                                                name="phone_no"
                                                onChange={formik.handleChange}
                                            />
                                        </div>

                                        <div className="form-box-inputs custom-input-box flex-column">
                                            <input
                                                type="number"
                                                value={formik.values.ss_number}
                                                placeholder="Social Security Number"
                                                name="ss_number"
                                                onChange={formik.handleChange}
                                            />
                                        </div>

                                        <div className="mb-3 custom-input-box">
                                            <input
                                                type="email"
                                                value={formik.values.email}
                                                placeholder="Email Address"
                                                name="email"
                                                disabled={true}
                                                onChange={formik.handleChange}
                                            />
                                        </div>

                                        {/* <div className="mb-3 custom-input-box">
                                            <input
                                                type="text"
                                                value={formik.values.address}
                                                placeholder="Address"
                                                name="address"
                                                onChange={formik.handleChange}
                                            />
                                        </div> */}

                                        <div className="mb-3 custom-input-box">
                                            {isLoaded && (
                                                <StandaloneSearchBox
                                                    onLoad={(ref) => (inputRef.current = ref)}
                                                    onPlacesChanged={handlePlacesChange}
                                                >
                                                    <input
                                                        type="text"
                                                        value={formik.values.address}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        className="form-control"
                                                        name="address"
                                                        placeholder="Enter your address"
                                                    />
                                                </StandaloneSearchBox>
                                            )}
                                        </div>

                                        <div className="mb-3 custom-input-box">
                                            <textarea
                                                placeholder="About Employee"
                                                value={formik.values.about}
                                                name="about"
                                                onChange={formik.handleChange}
                                                className='w-100'
                                            ></textarea>
                                        </div>

                                        <div className="logo-box">
                                            <h3 className="second-text-heading mb-3">Add Services</h3>

                                            <span
                                                className="add-services-button"
                                                data-bs-toggle="modal"
                                                href="#exampleModalToggle"
                                                role="button"
                                            >
                                                Add Services <i className="fa-solid fa-plus"></i>
                                            </span>

                                            <div className="services-array-box">
                                                {singleUserDetial?.services?.map((item, index) => {
                                                    return (
                                                        <span key={index}>
                                                            {item?.name}
                                                            <i className="fas fa-trash delete-icon" onClick={() => employeeServicesDelete(item?.id)}></i>
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        <div className="flex-center-box mb-5">
                                            <div className="logo-box">
                                                <h3 className="second-text-heading mt-2">Profile Picture</h3>
                                                <label htmlFor="upload-image" className="upload-image">
                                                    <span className="bg-white">Upload Image</span>
                                                </label>
                                                <input
                                                    type="file"
                                                    className="d-none"
                                                    id="upload-image"
                                                    accept="image/*"
                                                    name="profile"
                                                    onChange={handleImageChange}
                                                />
                                            </div>

                                            <div className="logo-box">
                                                <h3 className="second-text-heading mt-2 mb-0">Attached Document</h3>

                                                {<p className='mt-2 mb-2' style={{ wordBreak: "break-all" }}><strong>Document Name:</strong> {showOtherDocument}</p>}

                                                <label htmlFor="upload-image-2" className="upload-image">
                                                    <span className="bg-white">Upload Image</span>
                                                </label>
                                                <input
                                                    type="file"
                                                    className="d-none"
                                                    id="upload-image-2"
                                                    accept=".pdf,.doc,.docx"
                                                    name="other"
                                                    onChange={handleDocumentChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="submit-btn-form">
                                            <button type="submit" disabled={updateEmployeeloading} className="btn btn-primary">
                                                {!updateEmployeeloading ? (
                                                    "Update"
                                                ) : (
                                                    <i
                                                        style={{ fontSize: "22px" }}
                                                        className="fa-solid fa-spinner fa-spin"
                                                    ></i>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>

                                <div className="col-md-5">
                                    <div className="profile-image">
                                        {employeeImagePreview ? (
                                            <img src={employeeImagePreview} alt="Uploaded Preview" className="uploaded-image" />
                                        ) : (
                                            <i className="fa-solid fa-user dummy-user-icon"></i>
                                        )}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                {/*********************MODELS HERE************************/}
                <div
                    className="modal fade"
                    data-bs-backdrop="static"
                    id="exampleModalToggle"
                    aria-hidden="true"
                    aria-labelledby="exampleModalToggleLabel"
                    tabIndex={-1}
                >
                    <div className="modal-dialog modal-dialog-centered service-add-model">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="btn-close"
                                    id="close-btn-services"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <form onSubmit={addServiceshandleSubmit}>
                                                <div className="employee-form-box">
                                                    <h2>Add Service:</h2>
                                                </div>

                                                <div className="add-service-box">
                                                    <div className="add-service-input custom-input-box">
                                                        <select
                                                            name="name"
                                                            className="add-service-control"
                                                            value={addServicesFormData.name}
                                                            onChange={addServiceshandleChange}
                                                        >
                                                            <option value="" disabled>
                                                                Select Service
                                                            </option>

                                                            {services?.map((item, index) => {
                                                                return <option value={item?.label} key={index}>{item?.label}</option>
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="add-service-box custom-input-box">
                                                    <label htmlFor="currency-select">Select Currency:</label>
                                                    <select
                                                        name="currency"
                                                        id="currency-select"
                                                        className="form-control add-service-control"
                                                        value={addServicesFormData.currency}
                                                        onChange={addServiceshandleChange}
                                                    >
                                                        {/* <option value="" disabled>
                                                            Select Currency
                                                        </option> */}
                                                        <option value="USD" selected>USD</option>
                                                        <option value="POUND">POUND</option>
                                                        <option value="PKR">PKR</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <h3 className="form-sub-heading">Price per hour:</h3>
                                                    <div className="price-service-box">
                                                        <div className="add-service-input custom-input-box">
                                                            <span className="currency-symbol">
                                                                {addServicesFormData.currency === "USD"
                                                                    ? "$"
                                                                    : addServicesFormData.currency === "Pound"
                                                                        ? "£"
                                                                        : addServicesFormData.currency === "PKR"
                                                                            ? "₨"
                                                                            : "$"}
                                                            </span>
                                                            <input
                                                                type="number"
                                                                className="price-input"
                                                                name="price"
                                                                value={addServicesFormData.price}
                                                                onChange={addServiceshandleChange}
                                                                placeholder="Enter custom price"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="submit-btn-form justify-content-end mb-4 mt-4">
                                                    <button type="submit" disabled={loading} className="btn btn-primary">
                                                        {!loading ? (
                                                            "Save"
                                                        ) : (
                                                            <i
                                                                style={{ fontSize: "22px" }}
                                                                className="fa-solid fa-spinner fa-spin"
                                                            ></i>
                                                        )}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*********************MODELS HERE************************/}
            </DashboardLayout>
        </>
    )
}

export default UpdateEmployee